import React, { useRef } from 'react';
import useRevealOnScroll from '../../hooks/useRevealOnScroll';

const SelectedSystemsV2 = ({ copy }) => {
  const ref = useRef(null);
  useRevealOnScroll(ref);
  if (!copy) return null;
  return (
    <section ref={ref} className="iv2-selected-systems" id="work" data-testid="iv2-selected-systems">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <p className="iv2-selected-systems-lede">{copy.lede}</p>
        <ul className="iv2-selected-systems-list">
          {copy.systems.map((s) => (
            <li key={s.id} className="iv2-selected-system" data-testid={`iv2-selected-system-${s.id}`}>
              <h3 className="iv2-selected-system-title">{s.title}</h3>
              <p className="iv2-selected-system-body">{s.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
export default SelectedSystemsV2;
